<!-- Overlay de rate limiting -->
<app-rate-limit-overlay></app-rate-limit-overlay>

<!-- Contenido normal (se oculta cuando hay rate limiting) -->
<div *ngIf="!rateLimitActive" class="normal-content">
<div class="web">
  <div class="consultaContainer">
    <div class="consultaCenter">
      <div class="container-fluid mt-1" style="padding: 0;">
            <div class="row" style="margin: 0;padding: 0; padding-top: 1rem;">
              <div class="col-sm-12" style="margin: 0;padding: 0;">
                <div *ngIf="fResultados">
                  <p style="margin: 5px;padding: 0;">
                      <span class="tituloPanel">Páginas Históricas</span>
                  </p>
                  <p style="margin: 0;padding: 0;">
                    <span class="titulo">{{tagChoosen}}</span>
                  </p>
                  <p style="margin: 5px 0; padding: 0;">
                    <span class="resultados-text">
                      {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'resultado encontrado' : 'resultados encontrados' }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <!-- Paginación superior -->
            <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
              <nav class="my-4">
                <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                    <!--First-->
                    <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                    <!--Arrow left-->
                    <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                            <span class="sr-only">Anterior</span>
                        </a>
                    </li>
                    <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                    <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                        <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                            <span class="sr-only">Siguiente</span>
                        </a>
                    </li>
                    <!--Last-->
                    <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">Último</a></li>
                </ul>
              </nav>
            </div>

            <div class="col-sm-12">
              <div class="container-fluid">
                <div *ngIf="fResultados1">
                  <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                  <br>
                  <span style="margin-top: 10px;">No se encontraron resultados</span>
                </div>
                <div *ngIf="fResultados">
                  <div *ngIf="lblFecIni && lblFecFin && !lblTextoBusqueda">
                    <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                    <br>
                  </div>
                  <div *ngIf="lblTextoBusqueda && !lblFecIni && !lblFecFin">
                    <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}}</span>
                    <br>
                  </div>
                  <div *ngIf="lblFecIni && lblFecFin && lblTextoBusqueda">
                    <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}} Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                    <br>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin: 0;padding: 0; padding-top: 0.25rem;">
              <div class="col-sm-12 mt-1" style="padding: 0;">
                <div class="container-fluid">
                <!-- Dropdown de ordenamiento arriba a la derecha -->
                <!-- <div class="row" style="margin-bottom: 15px;" *ngIf="fResultados">
                  <div class="col-sm-8"></div>
                  <div class="col-sm-4 text-right">
                    <select class="form-control form-control-sm d-inline-block" style="width: auto; display: inline-block;" (change)="onSortChange($event.target.value)" [value]="currentSortValue">
                      <option value="">Ordenar por</option>
                      <option value="alfabetico_asc">Alfabético A-Z</option>
                      <option value="alfabetico_desc">Alfabético Z-A</option>
                      <option value="fecha_asc">Fecha Ascendente</option>
                      <option value="fecha_desc">Fecha Descendente</option>
                    </select>
                  </div>
                </div> -->
                    <div class="row" *ngIf="!fMerchadising">
                          <div class="contenedor-galeria">
                            <div class="columna-galeria" *ngFor="let columna of columnas">
                              <div class="item-galeria" *ngFor="let item of columna">
                              
                                <div class="panelLibWeb" *ngIf="fResultados" [routerLink]="['/dtp/'].concat(item.titleShowUrl).concat(item.id)" style="cursor: pointer;" (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave($event)">
                                  <div class="container-fluid" style="padding: 0;">
                                    <div class="row">
                                      <div class="col-sm-6" style="padding: 0 15px;">
                                        <!-- Skeleton SIN marco -->
                                        <div *ngIf="shouldShowSkeleton(item.activoId)"
                                             class="skeleton-container"
                                             style="width: 100%; margin-top: 5px;"
                                             [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                                          <app-image-skeleton
                                            [width]="'100%'"
                                            [height]="'100%'"
                                            size="large"
                                            class="skeleton-portrait">
                                          </app-image-skeleton>
                                        </div>

                                        <!-- Imagen CON marco (solo cuando está cargada) -->
                                        <a *ngIf="!shouldShowSkeleton(item.activoId)" class="btnDetalleFoto imagen-3d" >
                                          <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                            <img class="img-fluid"
                                                 [src]="getProtectedImageUrl(item.activoId)"
                                                 width="100%"
                                                 alt="{{ item.title }} - Imagen Protegida">
                                          </ng-container>
                                        </a>

                                        <!-- Ver detalle completo debajo de la imagen -->
                                        <div class="ver-mas-indicator">
                                          <span>Ver detalle completo</span>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M5.5 7a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L11.293 7H5.5z"/>
                                          </svg>
                                        </div>
                                      </div>
                                      <div class="col-sm-6" style="padding: 0; padding-right: 5px; text-align: left; position: relative;">
                                        <p class="tituloFoto" >{{item.title}}</p>
                                        <p class="descripcionFoto">{{item.subtitle}}</p>
                                        <p></p>
                                        <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                                        <p class="descripcionFoto">{{item.description}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                    </div>
                    <div class="row" *ngIf="!fMerchadising">
                      <div class="col-sm-4"></div>
                      <div class="col-sm-4 text-center">
                        <nav class="my-4" *ngIf="fResultados">
                          <ul class="pagination pagination-circle pg-red mb-0">
                            <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                              <a class="page-link" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Anterior</span>
                              </a>
                            </li>
                            <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index">
                              <a (click)="cambiarPagina(a+1)" class="page-link">{{a+1}}</a>
                            </li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                              <a class="page-link" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Siguiente</span>
                              </a>
                            </li>
                            <li class="page-item" (click)="cambiarPagina(totalPaginas)">
                              <a class="page-link">Último</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <div class="col-sm-4"></div>
                    </div>
                </div>
              </div>
            </div>

      </div>
    </div>
  </div>
</div>

<div class="movil">
  <div class="consultaContainerM">
    <div class="consultaCenterM">
  
        <div class="container-fluid mt-1" style="padding:0;">
                <div class="row" style="margin: 0;padding: 0; padding-top: 0.5rem;">
                  <div class="col-sm-12" style="margin: 0;padding: 0;">
                    <p style="margin: 0;padding: 0;">
                        <span class="tituloPanel">Páginas Históricas</span>
                    </p>
                    <p style="margin: 0;padding: 0;">
                      <span class="titulo">{{tagChoosen}}</span>
                    </p>
                  </div>
                </div>
                <div class="row" style="margin: 0;padding: 0; padding-top: 0.25rem;">
                    <div class="col-sm-12 text-center">
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12 mb-2" *ngIf="fSubCategoria">
                            <select class="dropdown-toggle waves-light btnSubtipo" (change)="cambiarSubCategoria($event.target.value)" [(ngModel)]="LSubCategoria" name="select">
                              <option *ngFor="let item of listSubCategoria.response.list" value="{{item.id}}">{{item.descript.charAt(0).toUpperCase() + item.descript.slice(1).toLowerCase()}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="container-fluid">
                        <!-- Header de resultados con contador -->
                        <div class="resultados-header" *ngIf="fResultados">
                          <span class="resultados-text">
                            Resultados: {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'encontrado' : 'encontrados' }}
                          </span>
                        </div>

                        <!-- Paginación superior -->
                        <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
                          <nav class="my-4">
                            <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                                <!--First-->
                                <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                                <!--Arrow left-->
                                <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                    <a class="page-link" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                </li>
                                <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                    <a class="page-link" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </li>
                                <!--Last-->
                                <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">&#187;&#187;</a></li>
                            </ul>
                          </nav>
                        </div>

                        <div *ngIf="fResultados1">
                          <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                          <br>
                          <span style="margin-top: 10px;">No se encontraron resultados</span>
                        </div>
                        <div *ngIf="fResultados">
                          <div *ngIf="lblFecIni && lblFecFin && !lblTextoBusqueda">
                            <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                            <br>
                          </div>
                          <div *ngIf="lblTextoBusqueda && !lblFecIni && !lblFecFin">
                            <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}}</span>
                            <br>
                          </div>
                          <div *ngIf="lblFecIni && lblFecFin && lblTextoBusqueda">
                            <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}} Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                            <br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 mt-1" style="padding: 0;">
                      <div class="container-fluid">
                        <div class="row" *ngIf="!fMerchadising">
                            <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of listProductos.response.list" style="padding: 0;">
                                <div class="panelLibMovil" *ngIf="fResultados" style="cursor: pointer;" [routerLink]="['/dtp/'].concat(item.titleShowUrl).concat(item.id)">
                                  <div class="container-fluid">
                                    <div class="row">
                                      <div class="col-6">
                                        <!-- Skeleton SIN marco -->
                                        <div *ngIf="shouldShowSkeleton(item.activoId)"
                                             class="skeleton-container"
                                             style="width: 100%; margin-top: 5px;"
                                             [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                                          <app-image-skeleton
                                            [width]="'100%'"
                                            [height]="'100%'"
                                            size="large"
                                            class="skeleton-portrait">
                                          </app-image-skeleton>
                                        </div>

                                        <!-- Imagen CON marco holográfico (solo cuando está cargada) -->
                                        <a *ngIf="!shouldShowSkeleton(item.activoId)" class="btnDetalleFoto" >
                                          <div class="marco-container-mobile">
                                            <div class="imagen-container-holografico-mobile">
                                              <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                                <img class="img-fluid"
                                                     [src]="getProtectedImageUrl(item.activoId)"
                                                     width="100%"
                                                     alt="{{ item.title }} - Imagen Protegida">
                                              </ng-container>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                      <div class="col-6" style="text-align: left;">
                                        <p class="tituloFoto">{{item.title}}</p>
                                        <p class="descripcionFoto">{{item.subtitle}}</p>
                                        <p></p>
                                        <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                                        <p class="descripcionFoto">{{item.description}}</p>
                                   
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="!fMerchadising">
                          <div class="col-sm-4"></div>
                          <div class="col-sm-4 text-center">
                            <nav class="my-4" *ngIf="fResultados">
                              <ul class="pagination pagination-circle pg-red mb-0">
                                <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                  <a class="page-link" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Anterior</span>
                                  </a>
                                </li>
                                <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index">
                                  <a (click)="cambiarPagina(a+1)" class="page-link">{{a+1}}</a>
                                </li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                  <a class="page-link" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Siguiente</span>
                                  </a>
                                </li>
                                <li class="page-item" (click)="cambiarPagina(totalPaginas)">
                                  <a class="page-link">&#187;&#187;</a>
                                </li>
                              </ul>
                            </nav>
                          </div>
                          <div class="col-sm-4"></div>
                        </div>
                    </div>
                </div>
          </div>
      </div>
    </div>
  </div>
</div>
<!-- Fin del contenido normal -->